import { Rule } from "antd/lib/form";
import { StoreValue } from "antd/lib/form/interface";
import { TypeCommon } from "models/common";

export const converSchemaToAntdRule = (schema: TypeCommon): Rule => {
  return {
    async validator(ruleObject: TypeCommon, value: StoreValue): Promise<void> {
      const field = "field";
      schema.validateSyncAt(ruleObject[field], {
        [ruleObject[field]]: value,
      });
    },
  };
};
